var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 22c-5.5142 0-10.00003-4.4858-10.00003-10 0-5.51417 4.48583-10 10.00003-10 5.5141 0 10 4.48583 10 10 0 5.5142-4.4859 10-10 10zm0-19.16667c-5.0542 0-9.1667 4.1125-9.1667 9.16667 0 5.0542 4.1125 9.1667 9.1667 9.1667 5.0541 0 9.1666-4.1125 9.1666-9.1667 0-5.05417-4.1125-9.16667-9.1666-9.16667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.08 17c-3.21 0-5.11253-1.1217-5.6567-3.3333h-1.00666c-.23 0-.41667-.1867-.41667-.4167s.18667-.4167.41667-.4167h.86833c-.02583-.26-.03833-.535-.03833-.8333h-.83c-.23 0-.41667-.1867-.41667-.4167s.18667-.4166.41667-.4166h.875c.4025-3.7292 3.48586-4.1667 5.78836-4.1667.23 0 .4166.18667.4166.41667s-.1866.41666-.4166.41666c-3.19 0-4.68586 1-4.9542 3.33337h3.7075c.23 0 .4167.1866.4167.4166s-.1867.4167-.4167.4167h-3.75333c0 .2933.015.5725.045.8333h2.87503c.23 0 .4166.1867.4166.4167s-.1866.4167-.4166.4167h-2.7092c.51084 1.7266 2.0025 2.5 4.7892 2.5.23 0 .4166.1866.4166.4166s-.1866.4167-.4166.4167z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.9993ad69b8ec0f271d908e08619e69c1.svg";
export { ForwardRef as ReactComponent };